module.exports = __webpack_public_path__ + "img/flexIcon.130db7ab.svg";